module.exports = __webpack_public_path__ + "static/media/modalBackground.1d83f9aa.png";